/* eslint-disable array-bracket-newline */
import { useDispatch, useSelector } from 'react-redux';
import { IUser } from '@kattana-io/common';
import Text from '../../../../atoms/Text';
import Image from '../../../../atoms/Image';
import { AVATAR_PLACEHOLDER } from '../../../../helpers/constants';
import { ModalTypes } from '../../../../reducers/modal';
import { actionShowModal } from '../../../../actions/modal';
import { authTokenSelector } from '../../../../selectors/auth';
import SidebarProfilePlaceholder from './Placeholder';
import PremiumTimer from '../../../../molecules/PremiumTimer';

import './styles.scss';

interface ISidebarProfileProps {
  user: IUser | null;
  userLoading: boolean;
  chain: string;
}

const SidebarProfile = ({ user, userLoading, chain }: ISidebarProfileProps) => {
  const authToken = useSelector(authTokenSelector);

  const dispatch = useDispatch();

  const internalNetwork = chain;
  let network = 'EVM';
  if (internalNetwork == 'ELROND') {
    network = 'ELROND';
  } else if (internalNetwork == 'TRON') {
    network = 'TRON';
  } else if (internalNetwork == 'TON') {
    network = 'TON';
  }

  const onEdit = () => {
    if (user && network && authToken) {
      dispatch(
        actionShowModal(ModalTypes.editProfile, { user, network, authToken })
      );
    }
  };

  const onChangeAvatar = () => {
    if (user && network && authToken) {
      dispatch(
        actionShowModal(ModalTypes.changeAvatar, { network, authToken })
      );
    }
  };

  if (userLoading) {
    return <SidebarProfilePlaceholder />;
  }

  return (
    <div className='sidebar_profile'>
      <div className='sidebar_profile__avatar' onClick={onChangeAvatar}>
        <Image size='xxl' src={user?.img_url || AVATAR_PLACEHOLDER} />
      </div>
      <div className='sidebar_profile__info'>
        <div className='sidebar_profile__info__nickname'>
          <Text size={14}>{user?.nickname || ''}</Text>
          <div
            className='sidebar_profile__info__nickname__icon icon-edit'
            onClick={onEdit}
          />
        </div>
        <Text size={12} className='text--grey-400'>
          <PremiumTimer />
        </Text>
        <div className='sidebar_profile__info__socials'>
          <a
            href={user?.twitter_url}
            className={`icon-twitter ${
              !user?.twitter_url
                ? 'sidebar_profile__info__socials--inactive'
                : ''
            }`}
            target='_blank'
            rel='noreferrer'
          />
          <a
            href={user?.facebook_url}
            className={`icon-facebook ${
              !user?.facebook_url
                ? 'sidebar_profile__info__socials--inactive'
                : ''
            }`}
            target='_blank'
            rel='noreferrer'
          />
          <a
            href={user?.github_url}
            className={`icon-github ${
              !user?.github_url
                ? 'sidebar_profile__info__socials--inactive'
                : ''
            }`}
            target='_blank'
            rel='noreferrer'
          />
        </div>
      </div>
    </div>
  );
};

export default SidebarProfile;
